module.exports = __webpack_public_path__ + "img/felixflos.c9369ded.png";